<template>
  <v-snackbar
    v-model="snackbar.visible"
    bottom
    :timeout="snackbar.timeout"
    transition="slide-y-reverse-transition"
    color="#292929"
    style="cursor: pointer"
    @click.native="closeSnackbar"
  >
    <v-row align="center" justify="center" dense>
      <v-col cols="auto" align-self="center">
        <v-icon :color="snackbar.iconColor">
          {{ snackbar.icon }}
        </v-icon>
      </v-col>

      <v-col v-if="snackbar.text !== ''" class="text-center">
        {{ snackbar.text }}
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<style>
.v-snack__wrapper {
  min-width: 0;
}

.v-snack__action {
  display: none;
}
</style>

<script>
import { mapMutations } from "vuex";

export default {
  name: "SnackBar",

  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
  },

  methods: { ...mapMutations(["closeSnackbar"]) },
};
</script>
